module.exports = __webpack_public_path__ + "img/circle-ooca-pricing.d0c8ad6e.png";